import { Component, Input } from '@angular/core';

import { statusProjetadoNaoProjetado } from '../../cliente-analise-mercado-status-projetado';
import { ClienteAnaliseMercadoStatusProjetadoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-projetado-badge-nao-projetado',
    templateUrl: './cliente-analise-mercado-status-projetado-badge-nao-projetado.component.html',
    styleUrls: ['./cliente-analise-mercado-status-projetado-badge-nao-projetado.component.less']
})
export class ClienteAnaliseMercadoStatusProjetadoBadgeNaoProjetadoComponent {
    status = statusProjetadoNaoProjetado;

    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusProjetadoPipe: ClienteAnaliseMercadoStatusProjetadoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusProjetadoPipe.transform(this.status.id);
    }
}
